// extracted by mini-css-extract-plugin
export default {"user-link":"_2JZC4","userLink":"_2JZC4","link-banned":"_3qv7r","linkBanned":"_3qv7r"};